module.exports = __webpack_public_path__ + "static/media/m3sblack.edbc6f8f.png";